import { createSearchParamsCache, createSerializer, parseAsInteger, parseAsString } from "nuqs/server";

export const faqSearchParams = {
  page: parseAsInteger.withDefault(1),
  category: parseAsString.withDefault("all"),
};

export const faqSearchParamsCache = createSearchParamsCache(faqSearchParams);
export const faqSerialize = createSerializer(faqSearchParams);
